import { CurrencyDisplayWrapper } from 'features/currency/currencyDisplayWrapper';

export interface TileData {
  label: string;
  count: number;
  metric?: string | number;
  currencyCode?: string;
  format: Intl.NumberFormat;
  percentageDiff?: number | undefined;
}

export const NumberTile = ({
  tileData: { label, count, metric, currencyCode, format, percentageDiff }
}: {
  tileData: TileData;
}) => {
  const shouldShowPercentageDiff =
    percentageDiff !== undefined && (percentageDiff > 0 || percentageDiff < 0);
  return (
    <>
      <div className="px-3 py-2" key={label}>
        <div className="flex items-center justify-between">
          <div>
            <header className="text-neutral-500 text-md leading-7 mb-1">
              {label}
            </header>
            <div className=" font-bold text-black text-3xl leading-8">
              {currencyCode ? (
                <CurrencyDisplayWrapper currencyCode={currencyCode}>
                  <>{format.format(count)}</>
                </CurrencyDisplayWrapper>
              ) : (
                format.format(count)
              )}
            </div>
          </div>
          {shouldShowPercentageDiff && percentageDiff !== undefined ? (
            <div
              className={`${
                percentageDiff < 0 ? 'text-error-300' : 'text-tertiary-600'
              } shrink bg-neutral-150 whitespace-pre py-0.5 px-2 -mt-10 rounded text-sm`}
            >
              <span>
                {percentageDiff < 0
                  ? format.format(percentageDiff)
                  : `+${format.format(percentageDiff)}`}
                %
              </span>
            </div>
          ) : null}
        </div>

        <div className="text-neutral-500 text-sm mt-6">{metric}</div>
      </div>
    </>
  );
};
